import { Container, Text, Link } from "@simplybusiness/mobius";
import type { PhoneNumber, Addresses } from "../types";
import type { OpeningHours } from "../../../types";
import logoFooter from "./logo-goco-footer.svg";

type FooterContentProps = {
  phoneNumber: PhoneNumber;
  openingHours: OpeningHours;
  addresses: Addresses;
};

export const FooterContent = ({
  phoneNumber,
  openingHours,
  addresses,
}: FooterContentProps) => {
  return (
    <>
      <Container size="sm" className="mobius-footer-gocompare__important-info">
        <Text elementType="h2">Important Information</Text>
        <p>
          To help you compare insurance and find the right cover for your
          requirements,{" "}
          <Link
            href="https://gocompare.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Gocompare.com
          </Link>{" "}
          Limited has selected Simply Business to provide you with quotes. If
          you would like more information about Simply Business, or how your
          data will be used, please click on the links below.
        </p>
        <p>
          Simply Business&apos;s office hours are{" "}
          {openingHours.find(element => element.day === "Mon")?.hours} Monday to
          Friday and{" "}
          {openingHours.find(element => element.day === "Sat")?.hours} on
          Saturday, and their contact number is {phoneNumber}. Calls are free of
          charge. Your call may be monitored or recorded for training and
          security purposes.
        </p>
      </Container>
      <div className="mobius-footer-gocompare__main">
        <Container size="sm">
          <nav className="mobius-footer-gocompare__nav">
            <ul>
              <li>
                <Link
                  href="https://www.simplybusiness.co.uk/terms-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms &amp; conditions
                </Link>
              </li>
              <li>
                <Link
                  href="https://www.simplybusiness.co.uk/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy statement
                </Link>
              </li>
              <li>
                <Link
                  href="https://www.simplybusiness.co.uk/legal/cookies/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie policy
                </Link>
              </li>
            </ul>
          </nav>
          <div className="mobius-footer-gocompare__footnote">
            <p>
              Xbridge Limited (trading as Simply Business) is registered in
              England and Wales, registered company number 03967717. Registered
              address {addresses[0]?.join(", ")}. Simply Business is authorised
              and regulated by the Financial Conduct Authority, registration
              number 313348. This can be confirmed at{" "}
              <Link
                href="https://register.fca.org.uk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                fca.org.uk
              </Link>
              .
            </p>
          </div>
          <div className="mobius-footer-gocompare__logo">
            <img src={logoFooter} alt="GoCompare" />
          </div>
        </Container>
      </div>
    </>
  );
};
